import React from 'react';
import { Phone, MapPin, Clock, Mail } from 'lucide-react';

const Contact = () => {
  return (
    <div style={{ paddingTop: '5rem' }}>
      {/* Contact Hero */}
      <section className="container" style={{ marginTop: '3rem', marginBottom: '4rem', textAlign: 'center' }}>
        <h1 className="heading-1" style={{ marginBottom: '1rem' }}>
          Contact Us
        </h1>
        <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto', color: 'var(--text-secondary)' }}>
          Reach out to us anytime. We're here 24/7 for your pet's health needs.
        </p>
      </section>

      {/* Contact Cards */}
      <section className="container" style={{ marginBottom: '4rem' }}>
        <div className="ai-grid">
          <div className="product-card">
            <div className="service-icon">
              <Phone size={32} />
            </div>
            <h3 className="product-card-title">Phone</h3>
            <p className="product-card-description" style={{ marginBottom: '1rem' }}>
              Call us anytime for appointments or emergencies
            </p>
            <a href="tel:+918199981444" className="link-text" style={{ fontSize: '1.1rem', fontWeight: '600' }}>
              +91 81999 81444
            </a>
          </div>

          <div className="product-card">
            <div className="service-icon">
              <MapPin size={32} />
            </div>
            <h3 className="product-card-title">Location</h3>
            <p className="product-card-description" style={{ marginBottom: '1rem' }}>
              Cosmo Club Road, near Varma's Kitchen,<br />
              Suryanarayana Puram, Tammi Raju Nagar,<br />
              Bhimavaram, Andhra Pradesh 534202
            </p>
            <p className="body-small" style={{ color: 'var(--accent-text)', fontWeight: '600' }}>
              Plus Code: GGV5+RJ Bhimavaram
            </p>
          </div>

          <div className="product-card">
            <div className="service-icon">
              <Clock size={32} />
            </div>
            <h3 className="product-card-title">Hours</h3>
            <p className="product-card-description" style={{ marginBottom: '1rem' }}>
              We're always here when you need us
            </p>
            <div style={{ fontSize: '1.1rem', fontWeight: '600', color: 'var(--accent-text)' }}>
              Open 24 Hours
            </div>
            <p className="body-small">Emergency Services Available</p>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="container" style={{ marginBottom: '4rem' }}>
        <h2 className="heading-2" style={{ textAlign: 'center', marginBottom: '2rem' }}>
          Find Us on the Map
        </h2>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3825.0989!2d81.509358!3d16.544439!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTbCsDMyJzM5LjkiTiA4McKwMzAnMzMuNyJF!5e0!3m2!1sen!2sin!4v1234567890"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Teja's Pet Care Location"
          ></iframe>
        </div>
        <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
          <a 
            href="https://www.google.com/maps/dir//GGV5+RJ+Bhimavaram,+Andhra+Pradesh/@16.544439,81.509358,16z?entry=ttu" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn-primary"
          >
            Get Directions
          </a>
        </div>
      </section>

      {/* Emergency Banner */}
      <section style={{ background: 'var(--accent-wash)', padding: '3rem 1.5rem' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <div className="emergency-banner" style={{ justifyContent: 'center', marginBottom: '1.5rem' }}>
            <Clock size={24} />
            <span style={{ fontSize: '1.2rem', fontWeight: '600' }}>Emergency? Call Immediately</span>
          </div>
          <h2 className="heading-2" style={{ marginBottom: '1rem' }}>
            24/7 Emergency Veterinary Care
          </h2>
          <p className="body-large" style={{ marginBottom: '2rem', color: 'var(--text-secondary)' }}>
            For life-threatening situations, don't hesitate. Call us right away.
          </p>
          <a href="tel:+918199981444" className="btn-primary" style={{ fontSize: '1.2rem', padding: '16px 32px' }}>
            <Phone size={24} />
            Emergency: +91 81999 81444
          </a>
        </div>
      </section>

      {/* Additional Info */}
      <section className="container" style={{ marginTop: '4rem', marginBottom: '4rem' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 className="heading-2" style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
            How to Reach Us
          </h2>
          <div className="body-medium" style={{ color: 'var(--text-body)' }}>
            <p style={{ marginBottom: '1rem' }}>
              <strong>By Phone:</strong> Call us at +91 81999 81444 for appointments, questions, or emergencies. 
              Our phone lines are staffed 24/7.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong>By Visit:</strong> Walk-ins are welcome! We're located on Cosmo Club Road near Varma's Kitchen 
              in Bhimavaram. Use the map above or Google Plus Code GGV5+RJ for easy navigation.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong>For Emergencies:</strong> If your pet is experiencing a life-threatening emergency, call ahead 
              if possible so we can prepare. Otherwise, come directly to our clinic - we're always open.
            </p>
            <p>
              <strong>For Street Animals:</strong> If you've found an injured street dog or cow that needs help, 
              contact us immediately. We provide free or low-cost care for community animals in need.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;